import axios from 'axios';
import MainLayout from "@/components/layout/MainLayout.vue";
import StarRating from "vue-star-rating";
import Pagination from "laravel-vue-pagination";
import VueSlider from "vue-slider-component";
import DatePicker from "vue2-datepicker";
import "vue-slider-component/theme/default.css";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters } from "vuex";
import LightBox from 'lightbox2';
import 'lightbox2/dist/css/lightbox.css';
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import moment from "moment";

const convertNumberService = new ConvertNumService();

export default {
    name: "classContentGroup",
    components: {
        MainLayout,
        StarRating,
        Pagination,
        DatePicker,
        VueSlider,
        AdvancedLaravelVuePaginate,
        Loading,
        LightBox,
    },

    data() {
        return {
            courses: {
                course_id: "",
                course_title: "",
                course_explanation: "",
                course_details: "",
                certificate: "",
                update_time: "",
                name: "",
                teacher_id: "",
                rate: 0,
                experience: "",
                defaultPic: "",
                course_type: "",
            },
            contents: {},
            lastPage: "",
            currentPage: "",
            courseId: this.$route.params.id,
            classId: this.$route.params.id,
            currentDate: "",
            accessEndDate:null,
            canLoadContent: false,
        }
    },
    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        async getContentList(page = 1) {
            try {
                const response = await axios.get(
                    `my/video-course/${this.$route.params.id}/content-gp?page=${page}`
                );
                this.contents = response.data;
                this.contents.total = convertNumberService.convertEng2Mm(this.contents.total);
                this.lastPage = convertNumberService.convertEng2Mm(this.contents.last_page);
                this.currentPage = convertNumberService.convertEng2Mm(this.contents.current_page);
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async getCourseDetail() {
            try {
                const response = await axios.get(`my/courses/${this.$route.params.id}`);
                this.courses = response.data;
                if (response.data.access_type == 2) {
                    const endDateResponse = await axios.get(
                        `my/courses/${this.$route.params.id}/get-end-date/${this.studentId}`
                    );
                    this.accessEndDate = endDateResponse.data.end_date;
                }
                if (!this.accessEndDate || this.accessEndDate >= this.currentDate) {
                    this.canLoadContent = true;
                    this.getContentList();
                }
            } catch (error) {
                this.handleApiError(error);
            }
        },

        handleApiError(error) {
            if (error.response) {
                const status = error.response.status;
                if (status === 404) this.$router.push({ name: "notFound" });
                if (status === 403) this.$router.push({ name: "forbidden" });
                if (status === 401) {
                    this.$store.commit("logout");
                    window.location.replace("/");
                }
            }
            console.error("API Error", error);
        },
    },

    filters: {
        setMoment: function (date) {
            return moment(date).format("DD MMMM YYYY");
        }
    },

    mounted() {
        const today = new Date();
        this.currentDate = today.toISOString().split("T")[0];
        this.getCourseDetail();
    }
};
